import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_update_asn_orderService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_id: number, update: $frontendTypes.FootprintApiManager.input_update_asn_order }): Promise<{ order?: $frontendTypes.FootprintApiManager.public_order, log?: any }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.update)) {
      $missingRequiredInParams.push('\'update\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

